import { useEffect, useRef, useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import { useLocation, useSearchParams } from "react-router-dom";
import { APP_URLS } from "../../../api/url";
import API from "../../../api/axios";
import { toast } from "react-toastify";
import Pagination from "../../../assets/SharedComponents/Pagination";
import NoRecord from "../../../assets/SharedComponents/Table/NoRecord";
import SearchKey from "../../../assets/SharedComponents/Search/SearchKey";
import { FaFilterIcon } from "../../../assets/Images/icon";
import ApprovalPopup from "./ApprovalPopup";
import { APIError, getOverflowState } from "../../../core/utils";
import {
  actionTypeOptions,
  approvalStatus,
  penaltyType,
  refundRequestType,
  refundRequestTypeText,
  requestType,
  userTypeTypo,
} from "../../../config/constant";
import faHide from "../../../assets/Images/icons/svgIcon/FaHide.svg";
import { Tooltip } from "@mui/material";
import RecordCount from "../../../assets/SharedComponents/RecordCount/RecordCount";
import BuyerCustomersFilter from "../../../assets/SharedComponents/Filters/BuyerCustomersFilter";
import SellerCustomersFilter from "../../../assets/SharedComponents/Filters/SellerCustomersFilter";
import StaticFilter from "../../../assets/SharedComponents/Filters/StaticFilter";
import moment from "moment";
import { AuctionReservationWrapper } from "./Style";
import { confirmAlert } from "react-confirm-alert";
import ViewAttachments from "./ViewAttachments";

const actionTypeList = Object.keys(actionTypeOptions).map((key) => ({
  name: key,
  value: actionTypeOptions[key],
}));

const CancelAuctionReservationRequest = () => {
  const search = useLocation().search;
  const query = new URLSearchParams(search);
  const [searchParams, setSearchParams] = useSearchParams();
  const [data, _data] = useState([]);
  const [searchkeyword, _searchkeyword] = useState(
    query.get("keyword") !== null ? query.get("keyword") : ""
  );
  const [page, setPage] = useState(
    query.get("page") !== null ? parseInt(query.get("page")) : 1
  );
  const [total, _total] = useState(0);
  const [totalPage, _totalPage] = useState(0);
  const [loaded, _loaded] = useState(false);
  const [popup, _popup] = useState(false);
  const [approved, _approved] = useState(false);
  const [requestedById, _requestedById] = useState("");
  const [requestId, _requestId] = useState("");
  const [show, _show] = useState("");
  const [countValue, _countValue] = useState(
    query.get("per_page") !== null ? parseInt(query.get("per_page")) : ""
  );
  const [filters, _filters] = useState(false);
  const [buyerID, _buyerID] = useState("");
  const [sellerID, _sellerID] = useState("");
  const [searchBuyerKeyword, _searchBuyerKeyword] = useState(
    query.get("sub_keyword") !== null ? query.get("sub_keyword") : ""
  );
  const [searchSellerKeyword, _searchSellerKeyword] = useState(
    query.get("sub_keyword") !== null ? query.get("sub_keyword") : ""
  );
  const [buyer, setBuyer] = useState(null);
  const [seller, setSeller] = useState(null);
  const [actionType, _actionType] = useState("");
  const [showReason, _showReason] = useState("");
  const [overflowStates, setOverflowStates] = useState({});
  const [isReject, _isReject] = useState(false);
  const [refundAmount, _refundAmount] = useState("");
  const refs = useRef({});

  useEffect(() => {
    getCancellationRequests();
  }, [page, countValue, approved, searchkeyword, buyer, seller, actionType]);

  const getCancellationRequests = () => {
    _loaded(true);
    API.get(`${APP_URLS.AUCTION_CANCEL_RESERVATION}?${getRestUrl()}`)
      .then((res) => {
        const resp = res.data;
        if (resp.success === true) {
          _data(resp.data.data);
          _total(resp.data.total);
          _totalPage(resp.data.last_page);
          _loaded(false);
        } else {
          toast.error(resp.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          _loaded(false);
        }
      })
      .catch(function (error) {
        _loaded(false);
        let error_message = APIError(error);
        toast.error(error_message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  //for showing reason comments
  const handleShowCancellationReason = (id) => {
    if (show) {
      _showReason("");
      _show(id === show ? "" : id);
    } else {
      _showReason("");
      _show(id);
    }
  };

  //for showing approval or rejection reason comments
  const handleShowRejectionReason = (id) => {
    if (showReason) {
      _show("");
      _showReason(id === showReason ? "" : id);
    } else {
      _show("");
      _showReason(id);
    }
  };

  //for showing approval or rejection reason comments
  const handleShowBuyerDisputeReason = (id) => {
    if (showReason) {
      _show("");
      _showReason(id === showReason ? "" : id);
    } else {
      _show("");
      _showReason(id);
    }
  };

  // function to get name and link
  function getNames(data) {
    const getNameAndLink = (person, isPro) => {
      const name =
        person.first_name || person.last_name
          ? `${person.first_name} ${person.last_name}`.trim()
          : person.name;

      const link = isPro
        ? `/company-details/${person.id}`
        : `/detail-member/${person.id}`;

      return { name, link, isPro };
    };

    // Extract the seller name and link
    const sellerInfo = data.seller_sub
      ? getNameAndLink(data.seller_sub, true)
      : getNameAndLink(data.seller_user, false);

    // Extract the buyer name and link
    const buyerInfo = data.buyer_sub
      ? getNameAndLink(data.buyer_sub, true)
      : getNameAndLink(data.buyer_user, false);

    // Return the seller and buyer info
    return { sellerInfo, buyerInfo };
  }

  //handles popup for history
  const handleApprovalPopup = (cancelRequest, rejectValue) => {
    _popup(true);
    _requestedById(cancelRequest?.requested_by);
    _requestId(cancelRequest?.id);
    _isReject(rejectValue);
    _refundAmount(cancelRequest.reservation_amount);
  };

  const handleSearchChange = (func, searchValue) => {
    func(searchValue);
    if (
      (func === _countValue && searchValue !== countValue) ||
      (func === _searchkeyword && searchValue !== searchkeyword)
    ) {
      if (searchValue !== "") {
        _totalPage(0);
        setPage(1);
      }
    }
  };

  //removing all filters
  const clearFilter = () => {
    _filters(true);
    setSeller(null);
    setBuyer(null);
    _buyerID("");
    _sellerID("");
    _actionType("");
    handleSearchChange(_countValue, "");
    handleSearchChange(_searchkeyword, "");
    if (searchkeyword !== "" || countValue !== "" || actionType !== "") {
      _totalPage(0);
      setPage(1);
    }
    for (var value of query.keys()) {
      const param = searchParams.get(value);
      if (param) {
        searchParams.delete(value);
        setSearchParams(searchParams);
      }
    }
  };

  //filter params
  function getRestUrl() {
    let urlParams = {};

    if (countValue) urlParams["per_page"] = countValue;
    if (searchkeyword) urlParams["keyword"] = searchkeyword;
    if (page > 1) urlParams["page"] = page;
    if (actionType) urlParams["filter[status]"] = actionType;
    // Add buyer and seller specific params
    if (buyer) {
      if (buyer.source === userTypeTypo.USER) {
        urlParams["filter[buyer_user_id]"] = buyer.value;
      } else if (buyer.source === userTypeTypo.SUBSIDIARY) {
        urlParams["filter[buyer_sub_id]"] = buyer.value;
      }
    }

    if (seller) {
      if (seller.source === userTypeTypo.USER) {
        urlParams["filter[seller_user_id]"] = seller.value;
      } else if (seller.source === userTypeTypo.SUBSIDIARY) {
        urlParams["filter[seller_sub_id]"] = seller.value;
      }
    }

    const restUrl = new URLSearchParams(urlParams);
    return restUrl;
  }

  //setting buyer value
  const setBuyerValue = (item) => {
    setBuyer(item);
    _buyerID(item.value);
    _totalPage(0);
    setPage(1);
    handleSearchChange(_searchkeyword, "");
  };

  //setting seller value
  const setSellerValue = (item) => {
    setSeller(item);
    _sellerID(item.value);
    _totalPage(0);
    setPage(1);
    handleSearchChange(_searchkeyword, "");
  };

  //getting total overflow and ellipses status after the data is rendered.
  useEffect(() => {
    const totalEllipsisData = getOverflowState(refs.current);
    setOverflowStates(totalEllipsisData);
  }, [data]);

  const handleAcceptCancellationByBuyer = (requestId) => {
    confirmAlert({
      title: "Confirm to accept",
      message: `Are you sure you want to accept this request?`,
      closeOnEscape: true,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            API.post(
              `${APP_URLS.AUCTION_CANCEL_RESERVATION_ACTION}/${requestId}/action?_method=patch`,
              {
                status: approvalStatus.ACCEPT,
                penalty: penaltyType.WITHOUT_PENALTY,
              }
            )
              .then((res) => {
                const resp = res.data;
                if (resp.success === true) {
                  toast.success("Request accepted successfully..", {
                    position: toast.POSITION.TOP_RIGHT,
                  });
                  getCancellationRequests();
                } else {
                  toast.error(resp.message, {
                    position: toast.POSITION.TOP_RIGHT,
                  });
                }
              })
              .catch(function (error) {
                let error_message = APIError(error);
                toast.error(error_message, {
                  position: toast.POSITION.TOP_RIGHT,
                });
              });
          },
        },
        {
          label: "No",
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "overlay-custom-class-name",
    });
  };

  return (
    <>
      <AuctionReservationWrapper>
        <div className="auctionMainContainer">
          <div className="row mt-4">
            <div className="col-md-12 text-align-center">
              <h1>CANCEL AUCTION RESERVATION REQUEST</h1>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-between info-wrap mt-3 mb-2">
            <div className="justify-content-end mt-1 me-2">
              <span className="text-start">
                Total Records : <b>{total}</b>
              </span>
            </div>
            <div className="justify-content-end mt-4 d-flex gap-2 mb-2 select-info align-items-center">
              <SellerCustomersFilter
                _filters={_filters}
                filters={filters}
                setSeller={(val) => setSellerValue(val)}
                seller={sellerID}
                searchSellerKeyword={searchSellerKeyword}
                _searchSellerKeyword={_searchSellerKeyword}
                type={"seller"}
              />
              <BuyerCustomersFilter
                _filters={_filters}
                filters={filters}
                setBuyer={(val) => setBuyerValue(val)}
                buyer={buyerID}
                searchBuyerKeyword={searchBuyerKeyword}
                _searchBuyerKeyword={_searchBuyerKeyword}
                type={"buyer"}
              />
              <SearchKey
                onSearchClick={(search) =>
                  handleSearchChange(_searchkeyword, search)
                }
                id="searchData"
                placeholder="Search by Vehicle title"
                val={searchkeyword}
                filters={filters}
                _filters={_filters}
              />
              <StaticFilter
                placeholder="Action Type"
                data={actionTypeList}
                handleChange={(e) => {
                  _actionType(e.target.value);
                  _totalPage(0);
                  setPage(1);
                }}
                value={actionType}
              />
              <RecordCount
                onSearchClick={(search) =>
                  handleSearchChange(_countValue, search)
                }
                id="pageCount"
                val={countValue}
                filters={filters}
                _filters={_filters}
              />
              <Tooltip title="Clear Filter" placement="bottom">
                <FaFilterIcon
                  className="filter-icon"
                  role="button"
                  onClick={clearFilter}
                />
              </Tooltip>
            </div>
          </div>
          <div className="tableContainer">
            <table className="auctionTable">
              <thead className="tableHead">
                <tr className="table-row">
                  <th className="maxwidth-110">ID</th>
                  <th className="minwidth-150">Seller name</th>
                  <th className="minwidth-150">Buyer name</th>
                  <th className="minwidth-150">Vehicle details</th>
                  <th className="maxwidth-110">Bid</th>
                  <th>Requested By</th>
                  <th className="minwidth-220">
                    Reservation cancellation reason
                  </th>
                  <th className="maxwidth-110">Penalty Requested</th>
                  <th>Approval</th>
                  <th className="minwidth-220">Rejection reason</th>
                  <th>Buyer Action</th>
                  <th className="minwidth-220">Buyer Reason</th>
                  <th>
                    Cancellation timeline
                    <br />
                    (Pre Sale/Post Sale)
                  </th>
                  <th className="minwidth-150">Attachments</th>
                  <th className="minwidth-150">Action</th>
                </tr>
              </thead>
              {loaded ? (
                <div className="d-flex justify-content-center three-dot">
                  <ThreeDots
                    height="150"
                    width="150"
                    radius="9"
                    color="#637df4"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                </div>
              ) : (
                <tbody>
                  {data.length > 0 ? (
                    data.map((cancelRequest) => {
                      const { sellerInfo, buyerInfo, isPro } =
                        getNames(cancelRequest);
                      const refundType =
                        cancelRequest.refund_request_type ==
                          refundRequestType.PRE_SALE
                          ? refundRequestTypeText.PRE_SALE
                          : cancelRequest.refund_request_type ==
                            refundRequestType.POST_SALE
                            ? refundRequestTypeText.POST_SALE
                            : "-";
                      return (
                        <>
                          <tr
                            className={
                              (cancelRequest.deleted_at ? "deletedRow" : "") +
                              " table-row"
                            }
                            key={cancelRequest.id}
                          >
                            <td className="maxwidth-110">{cancelRequest.id}</td>
                            <td className="minwidth-150">
                              <a
                                href={sellerInfo.link}
                                className="link"
                                title={sellerInfo.name}
                                target="_blank"
                              >
                                {sellerInfo.name}
                              </a>
                              <br />
                              <b>{sellerInfo.isPro ? "Pro" : "Private"}</b>
                            </td>
                            <td className="minwidth-150">
                              <a
                                href={buyerInfo.link}
                                className="link"
                                title={buyerInfo.name}
                                target="_blank"
                              >
                                {buyerInfo.name}
                              </a>
                              <br />
                              <b>{buyerInfo.isPro ? "Pro" : "Private"}</b>
                            </td>
                            <td className="minwidth-150">
                              <span
                                className="link"
                                onClick={() =>
                                  window.open(
                                    `${process.env.REACT_APP_FRONTOFFICE_URL_HTTPS}/fr/auction-ads/${cancelRequest.ad_vehicle.slug}`,
                                    "_blank"
                                  )
                                }
                              >
                                {cancelRequest?.owner_vehicle?.full_title}
                              </span>
                            </td>
                            <td className="maxwidth-110">
                              {cancelRequest?.ad_vehicle
                                ?.best_manual_bid_relation?.amount
                                ? `€ ${cancelRequest.ad_vehicle.best_manual_bid_relation.amount}`
                                : "-"}
                            </td>
                            <td>
                              {cancelRequest.requested_by === requestType.SELLER
                                ? "Seller"
                                : cancelRequest.requested_by ===
                                  requestType.BUYER
                                  ? "Buyer"
                                  : "-"}
                            </td>
                            <td className="minwidth-220">
                              {cancelRequest.reason ? (
                                <div className="d-flex flex-row align-items-center justify-content-center">
                                  <span
                                    className="message-text"
                                    ref={(el) =>
                                    (refs.current[
                                      `cancellation-reason-${cancelRequest.id}`
                                    ] = el)
                                    }
                                    title={cancelRequest.reason}
                                  >
                                    {cancelRequest.reason}
                                  </span>
                                  {overflowStates[
                                    `cancellation-reason-${cancelRequest.id}`
                                  ] ? (
                                    <img
                                      src={faHide}
                                      alt="show"
                                      className={
                                        (show === cancelRequest.id
                                          ? "close"
                                          : "open") + " dropbtn ms-2"
                                      }
                                      onClick={() =>
                                        handleShowCancellationReason(
                                          cancelRequest.id
                                        )
                                      }
                                    />
                                  ) : null}
                                </div>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td className="maxwidth-110">
                              {cancelRequest.user_penalty ===
                                penaltyType.WITH_PENALTY
                                ? "Yes"
                                : "No"}
                            </td>
                            <td>
                              {!!cancelRequest.status
                                ? cancelRequest.status ===
                                  approvalStatus.ACCEPT &&
                                  cancelRequest.penalty ===
                                  penaltyType.WITH_PENALTY
                                  ? "Approved with penalty"
                                  : cancelRequest.status ===
                                    approvalStatus.ACCEPT &&
                                    cancelRequest.penalty ===
                                    penaltyType.WITHOUT_PENALTY
                                    ? "Approved without penalty"
                                    : "-"
                                : "-"}
                            </td>
                            <td className="minwidth-220">
                              {cancelRequest.admin_reason ? (
                                <div className="d-flex flex-row align-items-center justify-content-center">
                                  <span
                                    className="message-text"
                                    ref={(el) =>
                                    (refs.current[
                                      `rejection-reason-${cancelRequest.id}`
                                    ] = el)
                                    }
                                    title={cancelRequest.admin_reason}
                                  >
                                    {cancelRequest.admin_reason}
                                  </span>
                                  {overflowStates[
                                    `rejection-reason-${cancelRequest.id}`
                                  ] ? (
                                    <img
                                      src={faHide}
                                      alt="show"
                                      className={
                                        (showReason === cancelRequest.id
                                          ? "close"
                                          : "open") + " dropbtn ms-2"
                                      }
                                      onClick={() =>
                                        handleShowRejectionReason(
                                          cancelRequest.id
                                        )
                                      }
                                    />
                                  ) : null}
                                </div>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>
                              {cancelRequest.buyer_dispute_response === 1 && (
                                <span className="disputeAction accepted">
                                  Penalty accepted
                                </span>
                              )}
                              {cancelRequest.buyer_dispute_response === 2 && (
                                <span className="disputeAction rejected">
                                  Dispute raised
                                </span>
                              )}
                              {!cancelRequest.buyer_dispute_response && (
                                <span>-</span>
                              )}
                            </td>
                            <td className="minwidth-220">
                              {cancelRequest.dispute_reason ? (
                                <div className="d-flex flex-row align-items-center justify-content-center">
                                  <span
                                    className="message-text"
                                    ref={(el) =>
                                    (refs.current[
                                      `rejection-reason-${cancelRequest.id}`
                                    ] = el)
                                    }
                                    title={cancelRequest.dispute_reason}
                                  >
                                    {cancelRequest.dispute_reason}
                                  </span>
                                  {overflowStates[
                                    `rejection-reason-${cancelRequest.id}`
                                  ] ? (
                                    <img
                                      src={faHide}
                                      alt="show"
                                      className={
                                        (showReason === cancelRequest.id
                                          ? "close"
                                          : "open") + " dropbtn ms-2"
                                      }
                                      onClick={() =>
                                        handleShowBuyerDisputeReason(
                                          cancelRequest.id
                                        )
                                      }
                                    />
                                  ) : null}
                                </div>
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>
                              <span className="d-block">
                                {moment(cancelRequest.created_at)
                                  .tz("Europe/Amsterdam")
                                  .format("DD-MM-YYYY HH:mm")}
                              </span>
                              <br />
                              {refundType}
                            </td>
                            <td className="minwidth-150">
                              <div className="attachmentsContainer">
                                {cancelRequest.buyer_has_image ?
                                  <ViewAttachments cancelRequestID={cancelRequest.id} title={"View Buyer Attachments"} type={requestType.BUYER} /> :
                                  "-"
                                }
                                {cancelRequest.seller_has_image ?
                                  <ViewAttachments cancelRequestID={cancelRequest.id} title={"View Seller Attachments"} type={requestType.SELLER} /> :
                                  "-"
                                }
                              </div>
                            </td>
                            <td className="minwidth-150">
                              <div className="access-btn">
                                {cancelRequest.status === null && (
                                  <>
                                    {cancelRequest.refund_request_type ===
                                      refundRequestType.POST_SALE &&
                                      cancelRequest.requested_by ===
                                      requestType.BUYER ? (
                                      <button
                                        className="accept"
                                        onClick={() =>
                                          handleAcceptCancellationByBuyer(
                                            cancelRequest.id
                                          )
                                        }
                                      >
                                        Accept
                                      </button>
                                    ) : (
                                      <button
                                        className="accept"
                                        onClick={() =>
                                          handleApprovalPopup(cancelRequest, 1)
                                        }
                                      >
                                        Accept
                                      </button>
                                    )}
                                    <button
                                      className="reject"
                                      onClick={() =>
                                        handleApprovalPopup(cancelRequest, 2)
                                      }
                                    >
                                      Reject
                                    </button>
                                    {cancelRequest.refund_request_type ===
                                      refundRequestType.POST_SALE && (
                                        <button
                                          className="reject"
                                          onClick={() =>
                                            handleApprovalPopup(cancelRequest, 3)
                                          }
                                        >
                                          Reject with penalty
                                        </button>
                                      )}
                                  </>
                                )}
                                {cancelRequest.status ===
                                  approvalStatus.ACCEPT && (
                                    <button className="accept disabled" disabled>
                                      Accepted
                                    </button>
                                  )}
                                {cancelRequest.status ===
                                  approvalStatus.REJECT && (
                                    <button className="reject disabled" disabled>
                                      Rejected
                                    </button>
                                  )}
                                {cancelRequest.status ===
                                  approvalStatus.REJECTWITHPENALTY && (
                                    <button className="reject disabled" disabled>
                                      Rejected with penalty
                                    </button>
                                  )}
                              </div>
                            </td>
                          </tr>
                          {show === cancelRequest.id ? (
                            <tr className="table-row">
                              <td className="dropped">
                                {cancelRequest.reason}
                              </td>
                            </tr>
                          ) : (
                            ""
                          )}
                          {showReason === cancelRequest.id ? (
                            <tr className="table-row">
                              <td className="dropped">
                                {cancelRequest.admin_reason}
                              </td>
                            </tr>
                          ) : (
                            ""
                          )}
                          {showReason === cancelRequest.id ? (
                            <tr className="table-row">
                              <td className="dropped">
                                {cancelRequest.dispute_reason}
                              </td>
                            </tr>
                          ) : (
                            ""
                          )}
                        </>
                      );
                    })
                  ) : (
                    <NoRecord />
                  )}
                </tbody>
              )}
            </table>
          </div>
          <div>
            {totalPage > 1 ? (
              <Pagination
                totalPages={totalPage}
                page={page}
                key={totalPage}
                onPageClick={(page) => setPage(page + 1)}
              />
            ) : (
              ""
            )}
          </div>
        </div>
        <ApprovalPopup
          popup={popup}
          _popup={_popup}
          requestedBy={requestedById}
          requestId={requestId}
          _approved={_approved}
          isReject={isReject}
          initialRefundAmount={refundAmount}
        />
      </AuctionReservationWrapper>
    </>
  );
};

export default CancelAuctionReservationRequest;
